import { FC, MouseEventHandler, ReactElement } from 'react';
import { GeneratedLinkUrlObject } from 'src/utils/links';
import Link from 'next/link';

export enum Targets {
  BLANK = '_blank',
  SELF = '_self',
  PARENT = '_parent',
  TOP = '_top'
}

interface Props {
  children: ReactElement | ReactElement[] | string | number;
  href: string | GeneratedLinkUrlObject;
  passClassName?: string;
  target?: string;
  shallow?: boolean;
  scroll?: boolean;
  onMouseEnter?: MouseEventHandler<HTMLAnchorElement>;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  prefetch?: boolean;
}

const NavigationLink: FC<Props> = ({
  href,
  children,
  passClassName = '',
  target = Targets.SELF,
  prefetch = false,
  ...otherProps
}) => {
  if (!href) {
    return null;
  }
  if (target === Targets.BLANK && typeof href === 'string') {
    return (
      <a
        href={href as string}
        target={target}
        className={passClassName}
        {...otherProps}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      href={href}
      target={target}
      className={passClassName}
      // Avoid logs "Next.js auto-prefetches automatically based on viewport. The prefetch attribute is no longer needed. More: https://nextjs.org/docs/messages/prefetch-true-deprecated"
      {...(!prefetch && { prefetch })}
      {...otherProps}
    >
      <>{children}</>
    </Link>
  );
};

export default NavigationLink;
